import determineErrorMessage from 'bl/response/determineErrorMessage.bl';
import S from 'constants/string.const';
import TYPE from 'constants/umsg/type.const';
import fromAnyToErrorMessage from 'utils/converters/any/fromAnyToErrorMessage.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import fromAnyToUmsgArg from 'utils/converters/umsg/fromAnyToUmsgArg.util';
import fromAnyToUmsgFn from 'utils/converters/umsg/fromAnyToUmsgFn.util';
import fromAnyToUmsgType from 'utils/converters/umsg/fromAnyToUmsgType.util';
import pubsub from 'utils/core/pubsub.util';
import logger from 'utils/logger.util';
import isNotEnumVal from 'utils/predicates/enum/isNotEnumVal.util';

const CTAG = 'UMSG';
const L = logger(CTAG);

const USE_DEBUG_LOG = true;

const LEVEL = Object.freeze({
  warning: 'warning',
  error: 'error',
});

const UMSG = {
  TYPE,
  LEVEL,
};

const sub = pubsub({ tag: CTAG, onBefore: () => UMSG });

UMSG.subscribe = sub.subscribe;
UMSG.unsubscribe = sub.unsubscribe;

UMSG.all = () => messages.map((message) => ({ ...message }));

const messages = [];

UMSG.determinePassMessage = (options) => {
  const value = options?.umsg;
  const type = fromAnyToUmsgType(value);

  if (TYPE.fn !== type) return determineErrorMessage(options);

  const fn = fromAnyToUmsgFn(value);
  const arg = fromAnyToUmsgArg(value);

  return fn(arg, options);
};

UMSG.determineFailMessage = (options) => {
  const value = options?.umsg;
  const type = fromAnyToUmsgType(value);

  if (TYPE.fn === type) {
    const fn = fromAnyToUmsgFn(value);
    const arg = fromAnyToUmsgArg(value);

    const result = fn(arg, options);
    L.debug('determineFailMessage()', options, '->', result);

    return result ? result : void 1;
  }

  const passMessage = UMSG.determinePassMessage(options);
  const errorMessage = fromAnyToErrorMessage(options?.error);

  return passMessage ? `${passMessage}${S.newline}Additional Information: ${errorMessage}` : errorMessage;
};

UMSG.add = (options) => {
  const isString = typeof options === 'string' || options instanceof String;

  const unique = fromAnyToBool(options?.unique);
  const message = isString ? options : fromAnyToString(options?.message);
  const level = isString || isNotEnumVal(LEVEL, options?.level) ? LEVEL.error : options.level;

  const index = messages.findIndex((item) => item?.message === message);

  const atag = options?.extra?.ATAG;
  const mtag = options?.extra?.MTAG;
  const status = options?.extra?.status;

  const isFound = -1 < index;
  if (unique && isFound) return;

  if (isFound) {
    messages[index].count = (messages[index].count ?? 0) + 1;
  } else {
    messages.push({ message, level, atag, mtag, status });
  }

  sub.raise();
};

UMSG.clear = () => {
  messages.splice(0);
  sub.raise();
};

UMSG.bePass = (options) => {
  try {
    if (USE_DEBUG_LOG) L.debug('bePass()', options);
    const message = UMSG.determinePassMessage(options);
    if (!message) return;

    UMSG.add({ message, level: LEVEL.warning, extra: options });
    sub.raise();
    //
  } catch (e) {
    L.warn('bePass()', e);
  }
};

UMSG.beFail = (options) => {
  try {
    if (USE_DEBUG_LOG) L.debug('beFail()', options);
    const message = UMSG.determineFailMessage(options);
    if (!message) return;

    UMSG.add({ message, level: LEVEL.error, extra: options });
    sub.raise();
    //
  } catch (e) {
    L.warn('beFail()', e);
  }
};

Object.freeze(UMSG);
export default UMSG;
